import {
  WISHLIST_PRINT,
  WISHLIST_PRINT_FULFILLED,
  WISHLIST_PRINT_REJECTED,
} from './actionTypes';
import {
  WishlistPrintAction,
  WishlistPrintFulfilledAction,
  WishlistPrintRejectedAction,
} from './types';

const wishlistPrint = (
  content: string,
  fileName: string,
): WishlistPrintAction => ({
  type: WISHLIST_PRINT,
  payload: {
    content,
    fileName,
  },
});

const wishlistPrintFulfilled = (): WishlistPrintFulfilledAction => ({
  type: WISHLIST_PRINT_FULFILLED,
});

const wishlistPrintRejected = (
  error: ErrorType,
): WishlistPrintRejectedAction => ({
  type: WISHLIST_PRINT_REJECTED,
  payload: {
    error,
  },
});

export {
  wishlistPrint,
  wishlistPrintFulfilled,
  wishlistPrintRejected,
};
